"use strict";

var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SskyAvatar = void 0;

const material_1 = require("@mui/material");

const md5_1 = __importDefault(require("md5"));

const react_1 = __importStar(require("react"));

const SskyTooltip_1 = __importDefault(require("../SskyTooltip"));

const GRAVATAR_ENDPOINT = "https://www.gravatar.com/avatar";
const StyledAvatar = (0, material_1.styled)(material_1.Avatar)({
  height: 40,
  width: 40
});
const SskyAvatar = (0, react_1.forwardRef)((props, ref) => {
  const {
    content,
    contentMd5,
    backgroundColor,
    className,
    tooltipContent,
    tooltipPlacement,
    onClick,
    isExtraAvatar
  } = props;
  const gravatarUrl = `${GRAVATAR_ENDPOINT}/${contentMd5 || (0, md5_1.default)(content)}.png?default=404`;
  const initials = isExtraAvatar ? content : content.split("@")[0].split(".").filter(word => word.length > 0).map(word => word[0]).join("").toUpperCase();
  const style = backgroundColor ? {
    backgroundColor
  } : {};
  const avatar = react_1.default.createElement(StyledAvatar, {
    alt: initials,
    src: gravatarUrl,
    className: className,
    onClick: onClick,
    style: style,
    ref: ref
  }, initials);

  if (tooltipPlacement) {
    return react_1.default.createElement(SskyTooltip_1.default, {
      id: content,
      title: tooltipContent !== null && tooltipContent !== void 0 ? tooltipContent : content,
      placement: tooltipPlacement
    }, avatar);
  } else {
    return avatar;
  }
});
exports.SskyAvatar = SskyAvatar;
exports.default = react_1.default.memo(SskyAvatar);